import React from 'react'
import { observer, inject } from 'mobx-react'
import Category from './Category'

const Categories = ({ categoriesStore, location }) => {
  const { mainCategories } = categoriesStore

  return (
    <ul className=''  style={{top:'7px', left:'-15px'}}>
      {
        mainCategories.map(category => {
          return <Category location={location} key={category._id} category={category}/>
        })
      }
    </ul>
  )
}

export default inject('categoriesStore')(observer(Categories))



// WEBPACK FOOTER //
// ./src/components/Header/Explore/Categories.js